export const ON_SHOW_MODAL = 'ON_SHOW_MODAL';
export const ON_CLOSE_MODAL = 'ON_CLOSE_MODAL';
